import { Box } from "@mui/material";
import type { ReactNode } from "react";

export function PageContentShell({ children }: { children: ReactNode }) {
  return (
    <Box component="main" sx={{ p: { xs: 2, md: 3 }, maxWidth: 1200, mx: "auto" }}>
      {children}
    </Box>
  );
}
